import styled from 'styled-components'

export const NotesContainer = styled.div`
  height: 120vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`

export const Heading = styled.h1`
  font-family: 'Bree Serif';
  font-size: 30px;
  font-weight: 600;
  color: #4c63b6;
  margin-bottom: 50px;
`

export const Form = styled.form`
  width: 70%;
  box-shadow: 0px 4px 18px 0px #475569;
  display: flex;
  flex-direction: column;
  padding: 40px 20px 10px 20px;
  border-radius: 10px;
`

export const Input = styled.input`
  margin-bottom: 20px;
  padding: 10px 20px;
  outline: none;
  border: none;
  font-family: 'Roboto';
  font-size: 18px;
  color: #1e293b;
  font-weight: 500;
`

export const Textarea = styled.textarea`
  margin-bottom: 20px;
  padding: 10px 20px;
  outline: none;
  border: none;
  font-family: 'Roboto';
  font-size: 18px;
  color: #1e293b;
  font-weight: 500;
`

export const AddBtn = styled.button`
  align-self: flex-end;
  padding: 10px 30px;
  font-family: 'Roboto';
  font-size: 18px;
  color: #ffffff;
  font-weight: 800;
  background-color: #4c63b6;
  outline: none;
  cursor: pointer;
  border: none;
  border-radius: 10px;
`
export const NoNotesContainer = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 70px;
`
export const NoNotesImage = styled.img`
  width: 100px;
`
export const NoNotesHeading = styled.h1`
  font-family: 'Roboto';
  font-size: 30px;
  font-weight: 500;
  color: #334155;
  margin-bottom: 0px;
`
export const NoNotesPara = styled.p`
  font-family: 'Roboto';
  font-size: 20px;
  color: #1e293b;
  margin-top: 10px;
  text-align: center;
`
export const NotesListContainer = styled.ul`
  width: 70%;
  margin-top: 30px;
  list-style-type: none;
  padding: 10px 0px;
  display: flex;
  flex-wrap: wrap;
`
